export default __webpack_public_path__ + "static/media/sasha.39cecb6a.jpg";